export const MAX_NFTS_PER_WALLET = 20
